// @ts-ignore
import { generateActions } from './utils'
import { createAction } from 'redux-actions'

const accountDefinition = {
  read: ['id'],
  fetchAccount: ['id'],
  updateAccount: ['id', 'data'],
  updateAccountContact: ['id', 'data'],
  updateAccountAddress: ['id', 'data'],
  loadInvoices: ['id'],
}

export const accountActions = generateActions(['ACCOUNT'], accountDefinition)

// Simple actions (no saga needed)
export const SET_CONNECTED_ACCOUNT = 'ACCOUNT.SET_CONNECTED_ACCOUNT'
export const SET_ME_LOADING = 'ACCOUNT.SET_ME_LOADING'
export const CLEAR_ME = 'ACCOUNT.CLEAR_ME'
export const SET_ME_INTEGRATION_ENABLED = 'ACCOUNT.SET_ME_INTEGRATION_ENABLED'

export const setConnectedAccount = createAction(SET_CONNECTED_ACCOUNT)
export const setMeLoading = createAction(SET_ME_LOADING)
export const clearMe = createAction(CLEAR_ME)

/**
 * Patches a single integration's enabled flag on `_meAccount`.
 *
 * Lets an integration toggle persist its confirmed result without refetching
 * the whole account.
 *
 * @param payload - `{ key: 'hockeycanada' | 'usahockey', enabled: boolean }`
 */
export const setMeIntegrationEnabled = createAction(SET_ME_INTEGRATION_ENABLED)

export default accountActions
